import { Config } from '@/config';

type TrackingParams = Record<string, string | number | boolean | undefined>;

interface TrackEventOptions {
  event: string;
  params?: TrackingParams;
  trackWith?: {
    facebook?: boolean;
    umami?: boolean;
  };
}

const fbq = (window as any).fbq;
const umami = (window as any).umami;

export function useTracker() {
  function track({ event, params = {}, trackWith = { umami: true } }: TrackEventOptions) {
    if (!Config.trackingEvents.enabled) return;
    trackWith.umami ??= true;
    trackWith.facebook &&= typeof fbq !== 'undefined';
    trackWith.umami &&= typeof umami !== 'undefined';
    const sanitizedParams = Object.entries(params).reduce<TrackingParams>((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = typeof value === 'string' ? value.trim() : value;
      }
      return acc;
    }, {});
    if (trackWith.facebook) fbq('track', event, sanitizedParams);
    if (trackWith.umami) umami.track(event, sanitizedParams);
  }
  return { track };
}
